import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const ConversationSettings = ({ config, onUpdate }) => {
  const [newStarter, setNewStarter] = useState('');
  const [newMessage, setNewMessage] = useState('');

  const handleToggleChange = (field, value) => {
    onUpdate({ [field]: value });
  };

  const addConversationStarter = () => {
    if (newStarter?.trim()) {
      const currentStarters = config?.conversation_starters || [];
      onUpdate({ 
        conversation_starters: [...currentStarters, newStarter?.trim()]
      });
      setNewStarter('');
    }
  };

  const removeConversationStarter = (index) => {
    const currentStarters = config?.conversation_starters || [];
    const updatedStarters = currentStarters?.filter((_, i) => i !== index);
    onUpdate({ conversation_starters: updatedStarters });
  };

  const addInitialMessage = () => {
    if (newMessage?.trim()) {
      const currentMessages = config?.initial_messages || [];
      onUpdate({ 
        initial_messages: [...currentMessages, newMessage?.trim()]
      });
      setNewMessage('');
    }
  };

  const removeInitialMessage = (index) => {
    const currentMessages = config?.initial_messages || [];
    const updatedMessages = currentMessages?.filter((_, i) => i !== index);
    onUpdate({ initial_messages: updatedMessages });
  };

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="MessageCircle" size={20} className="mr-2 text-primary" />
          Conversation Settings
        </h3>

        {/* Persistent Conversation */}
        <div className="mb-6">
          <div className="flex items-center space-x-3">
            <Checkbox
              id="persistent-conversation"
              checked={config?.persistent_conversation || false}
              onChange={(e) => handleToggleChange('persistent_conversation', e?.target?.checked)}
            />
            <label 
              htmlFor="persistent-conversation"
              className="text-sm font-medium text-foreground cursor-pointer"
            >
              Persistent Conversation Memory
            </label>
          </div>
          <p className="text-xs text-muted-foreground mt-2 ml-7">
            Agent remembers conversation context across sessions
          </p>
        </div>

        {/* Conversation Starters */}
        <div className="mb-6">
          <label className="text-sm font-medium text-foreground mb-3 block">
            Conversation Starters
          </label>
          
          <div className="flex gap-2 mb-3">
            <Input
              value={newStarter}
              onChange={(e) => setNewStarter(e?.target?.value)}
              placeholder="z.B. Wie kann ich Ihnen helfen?"
              className="flex-1"
            />
            <Button
              type="button"
              onClick={addConversationStarter}
              disabled={!newStarter?.trim()}
              size="sm"
            >
              <Icon name="Plus" size={16} className="mr-1" />
              Add
            </Button>
          </div>

          {config?.conversation_starters?.length > 0 && (
            <div className="space-y-2">
              {config?.conversation_starters?.map((starter, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between bg-muted/50 rounded-md px-3 py-2"
                >
                  <span className="text-sm">{starter}</span>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => removeConversationStarter(index)}
                    className="h-6 w-6 text-muted-foreground hover:text-destructive"
                  >
                    <Icon name="X" size={14} />
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Initial Messages */}
        <div>
          <label className="text-sm font-medium text-foreground mb-3 block">
            Initial Messages
          </label>
          
          <div className="flex gap-2 mb-3">
            <Input
              value={newMessage}
              onChange={(e) => setNewMessage(e?.target?.value)}
              placeholder="z.B. Willkommen! Ich bin Ihr AI-Assistent."
              className="flex-1"
            />
            <Button
              type="button"
              onClick={addInitialMessage}
              disabled={!newMessage?.trim()}
              size="sm"
            >
              <Icon name="Plus" size={16} className="mr-1" />
              Add
            </Button>
          </div>

          {config?.initial_messages?.length > 0 && (
            <div className="space-y-2">
              {config?.initial_messages?.map((message, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between bg-muted/50 rounded-md px-3 py-2"
                >
                  <span className="text-sm">{message}</span>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => removeInitialMessage(index)}
                    className="h-6 w-6 text-muted-foreground hover:text-destructive"
                  >
                    <Icon name="X" size={14} />
                  </Button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConversationSettings;